module.exports = __webpack_public_path__ + "static/payrollMpf-e781caa59615470e451269e1a9866dd4.jpg";